function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "b-818",
  d: "M192.736 0H16.686c-.642 0-1.276 0-1.916.003-.536.003-1.067.012-1.608.02a25.632 25.632 0 0 0-3.507.278c-1.158.177-2.28.51-3.327.988a11.297 11.297 0 0 0-2.832 1.856A9.975 9.975 0 0 0 1.434 5.7 9.69 9.69 0 0 0 .34 8.696a18.475 18.475 0 0 0-.313 3.153c-.017.483-.018.968-.027 1.45v36.406c.009.489.01.963.027 1.452.013 1.056.118 2.11.313 3.153a9.669 9.669 0 0 0 1.094 3 9.9 9.9 0 0 0 2.062 2.542 11.01 11.01 0 0 0 2.832 1.856c1.048.48 2.169.814 3.327.994 1.16.171 2.332.264 3.507.278.54.01 1.072.017 1.608.017.64.003 1.274.003 1.916.003h176.05c.629 0 1.268 0 1.897-.003.533 0 1.08-.006 1.613-.017a25.756 25.756 0 0 0 3.5-.278 12.85 12.85 0 0 0 3.34-.994 11.014 11.014 0 0 0 2.83-1.856 10.203 10.203 0 0 0 2.067-2.543 9.688 9.688 0 0 0 1.084-3c.195-1.041.304-2.095.325-3.152.006-.49.006-.963.006-1.452.014-.572.014-1.141.014-1.723V15.02c0-.576 0-1.149-.014-1.72 0-.482 0-.967-.006-1.45a19.21 19.21 0 0 0-.325-3.153 9.708 9.708 0 0 0-1.084-2.997c-1.08-1.895-2.793-3.437-4.897-4.41a12.784 12.784 0 0 0-3.34-.988 25.3 25.3 0 0 0-3.5-.278c-.533-.008-1.08-.017-1.613-.02C194.003 0 193.365 0 192.736 0z"
}), /*#__PURE__*/React.createElement("filter", {
  id: "a-817",
  width: "110.5%",
  height: "134.9%",
  x: "-5.3%",
  y: "-15.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 0.5,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.731053359 0 0 0 0 0.731053359 0 0 0 0 0.731053359 0 0 0 0.199898098 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a-817)",
  xlinkHref: "#b-818"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b-818"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M21.778 67.622c-.533 0-1.053-.006-1.582-.017a24.61 24.61 0 0 1-3.271-.257 11.11 11.11 0 0 1-2.9-.863 9.486 9.486 0 0 1-2.444-1.6 8.487 8.487 0 0 1-2.736-4.81 17.65 17.65 0 0 1-.292-2.954c-.01-.332-.025-1.438-.025-1.438V19.3s.015-1.09.025-1.41c.014-.987.11-1.973.29-2.948a8.446 8.446 0 0 1 .951-2.617 8.563 8.563 0 0 1 1.777-2.202 9.764 9.764 0 0 1 2.454-1.61 10.999 10.999 0 0 1 2.893-.857 24.413 24.413 0 0 1 3.282-.259l1.58-.019h179.844l1.598.02c1.09.012 2.177.097 3.252.256 1.017.156 2.003.446 2.924.863 1.817.842 3.294 2.175 4.227 3.811.456.819.771 1.694.936 2.598.182.982.284 1.976.304 2.972.006.446.006.925.006 1.402.013.59.013 1.153.013 1.72v32.962c0 .572 0 1.13-.013 1.693 0 .513 0 .982-.007 1.465-.02.978-.12 1.954-.3 2.919a8.416 8.416 0 0 1-.944 2.63 8.745 8.745 0 0 1-1.778 2.183 9.494 9.494 0 0 1-2.449 1.61c-.919.42-1.903.711-2.919.866a24.329 24.329 0 0 1-3.27.257c-.513.01-1.05.017-1.571.017l-1.897.003-177.958-.003z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.794 37.559c.04-3.019 1.656-5.807 4.283-7.388-1.664-2.327-4.353-3.75-7.254-3.84-3.052-.313-6.01 1.789-7.566 1.789-1.585 0-3.98-1.757-6.558-1.705-3.393.107-6.48 1.95-8.13 4.854-3.515 5.958-.893 14.714 2.474 19.53 1.685 2.358 3.654 4.992 6.23 4.899 2.52-.103 3.462-1.574 6.506-1.574 3.014 0 3.898 1.574 6.526 1.514 2.705-.043 4.41-2.369 6.035-4.749a19.34 19.34 0 0 0 2.76-5.503c-3.213-1.33-5.302-4.412-5.306-7.827z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.714 23.526a9.006 9.006 0 0 0 1.96-6.326 8.645 8.645 0 0 0-5.644 3.008 8.561 8.561 0 0 0-2.013 6.092c2.211.023 4.31-1 5.697-2.774z"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#000",
  letterSpacing: "0px",
  fontFamily: "StolzlRegular, Stolzl",
  fontSize: 10,
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 70,
  y: 19
}, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0432")), /*#__PURE__*/React.createElement("text", {
  fill: "#000",
  letterSpacing: "0px",
  fontFamily: "StolzlMedium, Stolzl",
  fontSize: 20,
  fontWeight: 400,
  transform: "translate(7 6)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 70,
  y: 47
}, "Apple Store")));

var SvgAppstore = function SvgAppstore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 77,
    viewBox: "0 0 224 77",
    className: "injected-svg",
    style: {
      height: 48,
      width: 145
    },
    "data-src": "/static/images/app-store.svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppstore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appstore.ce8b84f5.svg";
export { ForwardRef as ReactComponent };